/* global Modernizr */

const $search = $('.js-header-search');
const $searchToggler = $('.js-header-search-toggler');

const SEARCH_FOCUS_TIMEOUT = 50;
const SEARCH_INPUT_CLASS = '.js-header-search-input';
const SEARCH_OPEN_CLASS = 'is-open';
const BREAKPOINT_LG = 992;
const BREAKPOINT_LG_MAX = 991;

const headerSearch = {
  initialize() {
    if ($search.length && $searchToggler.length) {
      this.createEvents();
    }
  },

  /**
   * Create all events for the search in the header
   * @return {void}
   */
  createEvents() {
    $searchToggler.on((Modernizr.touchevents ? 'touchstart' : 'click'), (e) => {
      e.stopPropagation();
      e.preventDefault();

      // Check if the search is currently open
      const isOpen = $search.hasClass(SEARCH_OPEN_CLASS);

      // Toggle the search opened/closed
      $search.toggleClass(SEARCH_OPEN_CLASS, !isOpen);

      if (!isOpen) {
        // Focus on the search input field
        this.focusOn($search.find(SEARCH_INPUT_CLASS));
      }
    });
  },

  /**
   * Focus on element
   * @param {object} $el jQuery element object
   * @return {void}
   */
  focusOn($el) {
    setTimeout(() => {
      $el.focus();
    }, SEARCH_FOCUS_TIMEOUT);
  },

  /**
   * Test if the screen width is small
   * @return {Boolean} Is it a small screen width?
   */
  isSmallDevice() {
    return Modernizr.mq(`(max-width: ${BREAKPOINT_LG_MAX}px)`);
  },

  /**
   * Test if the screen width is large
   * @return {Boolean} Is it a large screen width?
   */
  isLargeDevice() {
    return Modernizr.mq(`(min-width: ${BREAKPOINT_LG}px)`);
  },
};

export default headerSearch;
